import { LayoutProps } from 'components/atoms/Layout/interfaces'
import { InputBuildProps } from 'components/molecules/InputBuild/interfaces'
import { SelectBuildProps } from 'components/molecules/SelectBuild/interfaces'
import { AgentResponseDTO, LocationsDTO } from 'models'
import { FormCreditorKeys } from './types'

interface Schema {
    id: FormCreditorKeys
}

export const FormCreditorValue = (
    location: LocationsDTO[],
    agentes: AgentResponseDTO[]
): {
    input?: InputBuildProps & Schema
    select?: SelectBuildProps & Schema
    layout: LayoutProps
}[] => [
    {
        select: {
            id: 'cnpj',
            label: 'Agentes financeiros',
            required: true,
            isLoading: true,
            options: agentes?.map(({ cnpj, razaoSocial }) => ({
                text: razaoSocial,
                value: cnpj
            }))
        },
        layout: {
            type: 'col',
            layout: { base: 12, md: 6 }
        }
    },
    {
        input: {
            id: 'email',
            label: 'Email',
            required: false
        },
        layout: {
            type: 'col',
            layout: { base: 12, md: 6 }
        }
    },
    {
        input: {
            id: 'endereco.cep',
            label: 'CEP',
            maskReplace: 'cep',
            inputMode: 'numeric',
            required: true,
            maxLength: 9
        },
        layout: {
            type: 'col',
            layout: { base: 12, md: 4 }
        }
    },
    {
        select: {
            id: 'endereco.uf',
            label: 'UF',
            required: true,
            optionsType: 'uf',
            isSearching: true,
            isDisable: true
        },
        layout: {
            type: 'col',
            layout: { base: 12, md: 2 }
        }
    },
    {
        select: {
            id: 'endereco.municipio',
            label: 'Município',
            options: location?.map(({ municipio, codigoTomDetran }) => ({
                text: municipio,
                value: `${String(codigoTomDetran)}|${municipio}`
            })),
            isSearching: true,
            required: true,
            isDisable: true
        },
        layout: {
            type: 'col',
            layout: { base: 12, md: 6 }
        }
    },
    {
        input: {
            id: 'endereco.logradouro',
            label: 'Logradouro',
            isSearching: true,
            required: true
        },
        layout: {
            type: 'col',
            layout: { base: 12, md: 6 }
        }
    },
    {
        input: {
            id: 'endereco.bairro',
            label: 'Bairro',
            isSearching: true,
            required: true
        },
        layout: {
            type: 'col',
            layout: { base: 12, md: 3 }
        }
    },
    {
        input: {
            id: 'endereco.numero',
            label: 'Número',
            isSearching: true,
            required: true
        },
        layout: {
            type: 'col',
            layout: { base: 12, md: 3 }
        }
    },
    {
        input: {
            id: 'endereco.complemento',
            label: 'Complemento ou referência',
            isSearching: true
        },
        layout: {
            type: 'col',
            layout: { base: 12, md: 5 }
        }
    },
    {
        input: {
            id: 'telefone',
            label: 'Telefone',
            maskReplace: 'contato',
            required: true
        },
        layout: {
            type: 'col',
            layout: { base: 12, md: 4 }
        }
    }
]
